
export default {
  props: {},
  components: {},
  data: function data() {
    return {
      activeName: '1',
      tab: [{
        label: '运营制作',
        value: '1'
      }, {
        label: '广告主制作',
        value: '2'
      }]
    };
  },

  methods: {
    handleClick: function handleClick() {
      this.$router.push({
        path: '/butler/custom-list/manage/' + this.activeName
      });
    }
  },
  computed: {
    innerTab: function innerTab() {
      if (this.$route.query.token) {
        return [this.tab[1]];
      }
      return this.tab;
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.activeName = this.$route.params.type;
    }
  },
  mounted: function mounted() {
    // console.log(this.$route.query.token)
    this.activeName = this.$route.params.type;
  }
};